import { Link } from 'react-router-dom'
import Facebook from '../../../assets/icons/Facebook'
import Instagram from '../../../assets/icons/InstagramImg'
import Linkedin from '../../../assets/icons/Linkedin'
import Twitter from '../../../assets/icons/Twitter'
import SectionHeader from '../Faq/SectionHeader'
import DefaultButton from '../../Button/Button'

const ReachOut = () => {
  return (
    <div>
      <div className="flex flex-col items-center gap-4 -mt-12">
        <SectionHeader
          className="max-w-[90%] lg:max-w-[59.75rem] mx-auto px-8 lg:px-40 text-center gap-1 lg:gap-3"
          subtitle="Various ways to contact our team"
          subTitleStyle="text-[22px] md:text-[40px] font-semibold md:font-normal whitespace-normal md:whitespace-nowrap"
          descriptionStyle="text-[13px] md:text-lg"
          description="You can reach out to us via phone calls, emails or our social media handles, we're are here to help!"
        />
        <div className="flex items-center gap-4">
          <Link to="https://www.instagram.com/safeltoapp">
            <Instagram />
          </Link>
          {/* <Facebook /> */}
          <Link to="https://www.linkedin.com/company/safelto/">
            <Linkedin />
          </Link>
          {/* <Twitter /> */}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20 w-full md:max-w-[69.5rem] mx-auto  px-6 md:p-8 ">
        <div className="flex flex-col items-start gap-8 rounded-lg bg-gray-50 px-6 md:p-8">
          <SectionHeader
            subtitle="Email Us"
            subTitleStyle="text-sm md:text-2xl font-semibold lg:font-normal mb-3"
            descriptionStyle="text-[13px] md:text-lg"
            description=""
          />
          <DefaultButton>
            <a href="mailto:safelto.app@gmail.com">safelto.app@gmail.com</a>
          </DefaultButton>{' '}
        </div>
        <div className="flex flex-col items-start gap-8 bg-[#FCFCFD] px-6 md:p-8">
          <SectionHeader
            subtitle="Call Us"
            subTitleStyle="text-sm md:text-2xl font-semibold lg:font-normal mb-3"
            descriptionStyle="text-[13px] md:text-lg"
            description=""
          />

          <DefaultButton>
            <a href="tel:+12095550104">(209) 555-0104</a>
          </DefaultButton>
        </div>
      </div>
    </div>
  )
}

export default ReachOut
